import _ from 'lodash'
import { useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { useGetBalanceHistoryQuery } from '@/store/api/paymentApi'
import { PROFILE_TRANSACTIONS_PER_PAGE } from '@/config/profile'
import { cn } from '@/lib/utils'
import { ProfilePagination } from '@/components/profile/ProfilePagination'
import { TransactionRow } from '@/components/profile/transactions/TransactionRow'
import { TransactionSkeletonRows } from '@/components/profile/transactions/TransactionSkeletonRows'

export function TransactionsPanel() {
	const [page, setPage] = useState(1)
	const { data, isLoading, isFetching, isError } = useGetBalanceHistoryQuery({
		page,
		per_page: PROFILE_TRANSACTIONS_PER_PAGE,
	})

	const transactions = data?.data ?? []
	const total = data?.total ?? 0

	return (
		<section className='overflow-hidden rounded-2xl border border-border bg-card shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
			<div className='px-4 py-4 sm:px-6'>
				<h2 className='text-lg font-semibold tracking-[-0.27px] text-foreground'>History transaction</h2>
			</div>

			<Table>
				<TableHeader>
					<TableRow className='border-border bg-secondary hover:bg-secondary'>
						<TableHead className='h-11 whitespace-nowrap px-3 text-xs text-muted-foreground sm:px-4 sm:text-sm'>Name</TableHead>
						<TableHead className='h-11 whitespace-nowrap px-3 text-xs text-muted-foreground sm:px-4 sm:text-sm'>Type</TableHead>
						<TableHead className='h-11 whitespace-nowrap px-3 text-xs text-muted-foreground sm:px-4 sm:text-sm'>Amount</TableHead>
						<TableHead className='hidden h-11 whitespace-nowrap px-3 text-xs text-muted-foreground sm:table-cell sm:px-4 sm:text-sm'>Balance Before</TableHead>
						<TableHead className='hidden h-11 whitespace-nowrap px-3 text-xs text-muted-foreground sm:px-4 sm:text-sm md:table-cell'>Balance After</TableHead>
						<TableHead className='h-11 whitespace-nowrap px-3 text-xs text-muted-foreground sm:px-4 sm:text-sm'>Date</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody className={cn(isFetching && !isLoading && 'opacity-70')}>
					{isLoading ? <TransactionSkeletonRows /> : null}
					{!isLoading && isError ? (
						<TableRow>
							<TableCell colSpan={6} className='py-10 text-center text-sm text-destructive'>
								Unable to load transaction history.
							</TableCell>
						</TableRow>
					) : null}
					{!isLoading && !isError && _.isEmpty(transactions) ? (
						<TableRow>
							<TableCell colSpan={6} className='py-10 text-center text-sm text-muted-foreground'>
								No transactions found.
							</TableCell>
						</TableRow>
					) : null}
					{!isLoading && !isError ? _.map(transactions, (transaction) => <TransactionRow key={transaction.id} transaction={transaction} />) : null}
				</TableBody>
			</Table>

			<ProfilePagination page={page} perPage={PROFILE_TRANSACTIONS_PER_PAGE} total={total} onPageChange={setPage} />
		</section>
	)
}
